<rc-document-wrapper
  [entity]="supplierCreditNote()"
  [documentItems$]="wrapperItems()"
  [documentType]="DocumentWrapperType.SALES_INVOICE"
  [documentClass]="'full-height'"
  [documentBarClass]="'document-bar-no-padding'"
  [notesCount]="notesBadgeCount()">
  <ng-template #topbarTemplate>
    <div class="g-col-8">
      <rc-breadcrumbs />
      <rc-copyable-title [titleParts]="titleParts()" />
    </div>
    <div class="g-col-4">
      <rc-overview-create-button />
    </div>
  </ng-template>

  <ng-template #documentBarTemplate>
    <div class="d-flex align-items-center">
      <button
        kendoButton
        class="bg-neutral-200"
        iconClass="rc-icon-link fs-16"
        [hidden]="supplierCreditNoteIsLocked()"
        (click)="linkDocument()">
        <span class="fw-500">{{ "LINK" | translate | capitalize }}</span>
      </button>

      @let clientInvoices = supplierCreditNote()!.clientInvoices;
      @let supplierInvoices = supplierCreditNote()!.supplierInvoices;
      @let clientCreditNotes = supplierCreditNote()!.clientCreditNotes;
      @if (clientInvoices.length > 0) {
        <button
          kendoButton
          [type]="'button'"
          class="link-button ps-24"
          (click)="openClientInvoiceLinksModal()"
          iconClass="rc-icon-sales-invoice fc-neutral-600">
          {{ clientInvoices.length }}
          {{ clientInvoices.length === 1 ? ("CLIENT_INVOICE" | translate) : ("CLIENT_INVOICES" | translate) }}
        </button>
      }
      @if (supplierInvoices.length > 0) {
        <button
          kendoButton
          [type]="'button'"
          class="link-button"
          (click)="openSupplierInvoiceLinksModal()"
          iconClass="rc-icon-purchase-invoice fc-neutral-600">
          {{ supplierInvoices.length }}
          {{ supplierInvoices.length === 1 ? ("SUPPLIER_INVOICE" | translate) : ("SUPPLIER_INVOICES" | translate) }}
        </button>
      }
      @if (clientCreditNotes.length > 0) {
        <button
          kendoButton
          [type]="'button'"
          class="link-button"
          (click)="openClientCreditNoteLinksModal()"
          iconClass="rc-icon-credit-note fc-neutral-600">
          {{ clientCreditNotes.length }}
          {{ clientCreditNotes.length === 1 ? ("CLIENT_CREDIT_NOTE" | translate) : ("CLIENT_CREDIT_NOTES" | translate) }}
        </button>
      }

      @let clients = clientNames();
      @let reference = supplierCreditNote()!.reference;
      <div class="d-flex align-items-center gap-16 ms-auto pe-32">
        @if (clients.length > 0) {
          <span class="d-flex gap-8 align-items-center fc-neutral-800"><i
            class="rc-icon-store fc-neutral-600"></i>{{ clients.join(', ') | uppercase }}</span>
        }
        @if (reference) {
          <span class="d-flex gap-8 align-items-center fc-neutral-800"><i
            class="rc-icon-bookmark fc-neutral-600"></i>{{ reference | uppercase }}</span>
        }
      </div>
    </div>
  </ng-template>

  <ng-template #invoiceDocumentTemplate>
    <div class="invoice-template-wrapper">
      <div class="supplier-credit-note-item-container">
        @let isLocked = supplierCreditNoteIsLocked();
        @if (wrapperItems()!.length > 0) {
          <div class="client-credit-note-item-header grid template-cols-36 align-items-center k-mb-4 ps-12">
            <div class="k-column-title g-col-auto" style="width: 36px"></div>
            <div class="k-column-title g-col-6">{{ "ARTICLE" | translate | capitalize }}</div>
            <div class="k-column-title g-col-5">{{ "DESCRIPTION" | translate | capitalize }}</div>
            <div class="k-column-title g-col-2 text-end">{{ "AMOUNT" | translate | capitalize }}</div>
            <div class="k-column-title g-col-4 text-end">{{ "RETAIL_PRICE" | translate | capitalize }}</div>
            <div class="k-column-title g-col-4 text-end">{{ "TAX_EXCL_VAT" | translate | capitalize }}</div>
            <div class="k-column-title g-col-3 text-end">{{ "BASIC_NET" | translate | capitalize }}</div>
            <div class="k-column-title g-col-4">{{ "CONDITIONS" | translate | capitalize }}</div>
            <div class="k-column-title g-col-4 text-end">{{ "SALES" | translate | capitalize }}</div>
            <div class="k-column-title g-col-3 text-end">{{ "TOTAL" | translate | capitalize }}</div>
          </div>
          <div class="supplier-credit-note-item-row k-d-flex k-flex-column">
            @for (item of wrapperItems(); track item['@id']) {
              <rc-supplier-credit-note-item
                [supplierCreditNote]="supplierCreditNote()!"
                [supplierCreditNoteItem]="item"
                [supplierCreditNoteItemMappings]="mappingsByItem().get(item['@id']!) ?? []"
                [clientCreditNoteDraftItems]="draftItemsByItem().get(item['@id']!) ?? []"
                [clientCreditNoteItems]="linkedItemsByItem().get(item['@id']!) ?? []"
                [supplierCreditNoteIsLocked]="isLocked"
                [readonly]="readonly()"
                (update)="updateSupplierCreditNoteItems($event)"
              />
            }
          </div>
        } @else {
          <div class="empty-placeholder">
            <div class="placeholder-logo bg-primary-200">
              <i class="m-auto bg-transparent rc-icon-text-plus fc-primary-700 fs-24"></i>
            </div>
            <div class="placeholder-text fc-neutral-800 fw-500 fs-16 mt-24">
              {{ "NO_ITEMS_FOUND" | translate | capitalize }}
            </div>
          </div>
        }
      </div>
    </div>
  </ng-template>

  <ng-template #documentFooterTemplate let-notesVisible="notesVisible" let-toggleTemplate="toggleTemplate">
    <div class="d-flex flex-column w-100">
      @if (supplierCreditNote() && notesVisible) {
        <form class="d-flex w-100" [formGroup]="supplierCreditNoteForm">
          <div class="grid w-100">
            <div class="d-flex flex-column g-col-12">
              <kendo-formfield showHints="initial" showErrors="initial">
                <kendo-label
                  labelCssClass="k-form-label"
                  [for]="internalNote"
                  [text]="'NOTES' | translate | uppercase"></kendo-label>
                <kendo-textarea
                  [rows]="3"
                  (valueChange)="updateSupplierCreditNote('internalNote')"
                  rcValidation
                  controlType="textArea"
                  formControlName="internalNote"
                  #internalNote></kendo-textarea>
              </kendo-formfield>
            </div>
          </div>
        </form>
      }
      <div class="d-flex gap-8 align-self-end my-32">
        <ng-container *ngTemplateOutlet="toggleTemplate"></ng-container>
        @if (state()) {
          <div class="d-flex gap-0">
          <button type="button"
                  class="gap-8 ms-auto border-top-right-radius-0 border-bottom-right-radius-0 bg-neutral-100 border-color-neutral-300 border-top-1 border-left-1 border-bottom-1 border-right-0"
                  kendoButton (click)="previous()" [disabled]="state()!.index === 0">
            <span class="d-flex gap-8 align-items-center"><i class="rc-icon-arrow-left fs-16 fc-neutral-600"></i> <span
              class="fw-500">{{ "PREVIOUS_ENTITY" | translate: { entity: "SUPPLIER_CREDIT_NOTE" | translate } | capitalize }}</span></span>
          </button>
          <button type="button" class="gap-8 ms-auto border-radius-0 bg-neutral-100 border-color-neutral-300 border-1"
                  kendoButton (click)="cancelButton()" (contextmenu)="onOverviewContextMenu($event)" (auxclick)="onAuxClick($event)">
            <span class="d-flex gap-8 align-items-center"><i class="rc-icon-list fs-16 fc-neutral-600 "></i> <span
              class="fw-500">{{ "OVERVIEW" | translate | capitalize }}</span></span>
          </button>
          <button type="button"
                  class="gap-8 ms-auto align-items-center border-top-left-radius-0 border-bottom-left-radius-0 bg-neutral-100 border-color-neutral-300 border-left-0 border-top-1 border-bottom-1 border-right-1"
                  kendoButton (click)="next()" [disabled]="state()!.index === state()!.idsOnPage.length -1">
            <span class="d-flex gap-8 align-items-center"><span
              class="fw-500">{{ "NEXT_ENTITY" | translate: { entity: "SUPPLIER_CREDIT_NOTE" | translate } | capitalize }}</span> <i
              class="rc-icon-arrow-right fs-16 fc-neutral-600"></i></span>
          </button>
          </div>
        } @else {
          <button type="button" class="me-2 ms-auto rc-cancel-button" kendoButton fillMode="link"
                  (click)="cancelButton()" (contextmenu)="onOverviewContextMenu($event)" (auxclick)="onAuxClick($event)">
            {{ (supplierCreditNote() ? "BACK_TO_OVERVIEW" : "CANCEL") | translate | capitalize }}
          </button>
        }
      </div>
    </div>
  </ng-template>

  <ng-template #sidebarTemplate let-readonly="readonly">
    <rc-supplier-credit-note-totals-and-taxes [supplierCreditNote]="supplierCreditNote()">
    </rc-supplier-credit-note-totals-and-taxes>
    <rc-supplier-credit-note-sidebar-panel
      [readonly]="readonly"
      [supplierCreditNote]="supplierCreditNote()"
      (updateTotals)="updateTotals()"
      class="d-flex flex-column flex-grow-1" />
  </ng-template>
</rc-document-wrapper>

<rc-table-modal [tableConfig]="tableConfig" (closeEvent)="close()" />
